// @flow

export type Chunk = {|
  id: string /* ID of group of messages that should be read as a single payload. */,
  chunksNumber: number /* Amount of chunks to construct full payload. */,
  chunk: string /* Payload of the chunk */,
  chunkId: number /* ID of the chunk (from 0 to N) used as index in an array. */,
|};

class CustomMessagesReader {
  id: string;
  chunksStorage: Array<Chunk> = [];
  chunksRead: number = 0;
  chunksNumber: number = 0;

  constructor(firstChunk: Chunk) {
    const { id, chunksNumber } = firstChunk;

    this.id = id;
    this.chunksNumber = chunksNumber;
  }

  /* Returns true if all of the readers have all of the chunks to parse the message. */
  append(chunk: Chunk): boolean {
    const { chunkId, chunksNumber, id } = chunk;

    if (this.id !== id) {
      throw Error(
        `CustomMessagesReader.append received the chunk with wrong id: expected ${
          this.id
        } - received ${id}`,
      );
    }

    if (typeof this.chunksStorage[chunkId] !== 'undefined') {
      throw Error(
        `CustomMessagesReader.append has already received chunk with that id ${chunkId} `,
      );
    }

    if (this.chunksNumber !== chunksNumber) {
      throw Error(
        `CustomMessagesReader.append received an inconsistent chunk - overall amount of chunks differ ${
          this.chunksNumber
        } vs ${chunksNumber}`,
      );
    }

    this.chunksStorage[chunkId] = chunk;
    this.chunksRead += 1;

    return this.hasFullPayload();
  }

  hasFullPayload = (): boolean => this.chunksNumber === this.chunksRead;

  getFullPayload(): ?Object {
    if (this.hasFullPayload() === false) {
      console.error(
        `CustomMessagesReader.getFullPayload fail to read the full payload - not enough chunks received: ${
          this.chunksRead
        } received, overall number ${this.chunksNumber}`,
      );
      return null;
    }

    const fullPayload = this.chunksStorage.map(({ chunk }) => chunk).join('');

    try {
      const parsed = JSON.parse(fullPayload);
      return parsed;
    } catch (e) {
      console.error(
        `CustomMessagesReader.getFullPayload fail to parse the payload (not valid JSON).`,
      );
      return null;
    }
  }
}

export { CustomMessagesReader };
